import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';

export const Wrapper = styled.section`
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  line-height: 0;
`;

export const CropableGatsbyImage = styled(GatsbyImage)`
  max-width: 1440px;
  height: 712px;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    height: 511px;
  }
`;

export const Content = styled.div`
  position: absolute;
  top: 0;
  left: 11.38%;
  right: 15px;
  color: #fff;
  max-width: 532px;

  @media screen and (max-width: 768px) {
    max-width: 468px;
    height: 511px;
    left: 13%;
  }
  @media screen and (max-width: 640px) {
    left: 15px;
    margin: 0 auto;
  }
`;
export const H1 = styled.h1`
  font-weight: 500;
  font-size: 52px;
  line-height: 122.9%;
  margin: 152px 0 20px;

  @media screen and (max-width: 768px) {
    margin: 130px 0 28px;
  }
  @media screen and (max-width: 640px) {
    font-size: 32px;
  }
`;
export const SubH1 = styled.p`
  font-size: 18px;
  line-height: 170%;
  margin: 0;
`;
